import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-functional-category-rate-pools',
  templateUrl: './functional-category-rate-pools.component.html',
  styleUrls: ['./functional-category-rate-pools.component.css']
})
export class FunctionalCategoryRatePoolsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/functional-category-rate-pools/functional-category-rate-pools.component.ts